module.exports = __webpack_public_path__ + "img/A-835496-1614134473-6649.jpeg.a0ca1ffc.jpg";